import React from 'react';
import { Select } from 'antd';
import { Building2 } from 'lucide-react';
import Globals from '../../config/globals';
import { useSelectedDashboardFacility } from '../../hooks/useSelectedDashboardFacility';

const { Option } = Select;

/**
 * Global facility selector for the dashboard. Replaces per-widget facility filters -
 * the selection here drives every widget on the dashboard for the current session.
 */
const ALL_FACILITIES_VALUE = '__all__';

export default function FacilitySelector({ theme }) {
    const { facility, facilities, setFacility, clearFacility } = useSelectedDashboardFacility();

    if (facilities.length === 0) return null;

    return (
        <div className="flex items-center gap-2 mb-4">
            <Building2 size={18} style={{ color: theme === 'dark' ? '#a1a1aa' : '#71717a' }} />
            <span className="text-sm font-medium" style={{ color: theme === 'dark' ? '#e4e4e7' : '#3f3f46' }}>
                Facility:
            </span>
            {facilities.length === 1 ? (
                <span className="text-sm" style={{ color: theme === 'dark' ? '#e4e4e7' : '#18181b' }}>
                    {facilities[0].facilityModel.facilityName}
                </span>
            ) : (
                <Select
                    placeholder="All Facilities"
                    value={facility?.facilityID ?? ALL_FACILITIES_VALUE}
                    onChange={(facilityID) => {
                        if (!facilityID || facilityID === ALL_FACILITIES_VALUE) {
                            clearFacility();
                            return;
                        }
                        const selected = facilities.find(f => f.facilityModel.facilityID === facilityID);
                        setFacility(selected ? selected.facilityModel : null);
                    }}
                    className="form-control-custom"
                    style={{ width: 220 }}
                    bordered={false}
                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    <Option value={ALL_FACILITIES_VALUE}>All Facilities</Option>
                    {facilities.map(f => (
                        <Option key={f.facilityModel.facilityID} value={f.facilityModel.facilityID}>
                            {f.facilityModel.facilityNumber
                                ? `${f.facilityModel.facilityNumber} - ${f.facilityModel.facilityName}`
                                : f.facilityModel.facilityName}
                        </Option>
                    ))}
                </Select>
            )}
        </div>
    );
}
